<template>
  <div class="relative w-$portalContainerWidth mx-auto">
    <NavigationBarProps v-model="active" :navList="titleBar"></NavigationBarProps>
    <el-row :gutter="10" class="h-700px mt-10px">
      <el-col :span="24">
        <div class="h-full w-full mr-10px" :body-style="{ height: '100%' }">
          <div class="flex justify-start items-center">
            <span class="text-hex-666">排序:</span>
            <span class="text-hex-$portalPrimaryColor cursor-pointer ml-8px"
              >按日期 <i class="el-icon-sort" @click="changeSort"></i
            ></span>
            <span class="text-hex-666 ml-40px">搜索位置:</span>
            <span class="text-hex-$portalPrimaryColor cursor-pointer ml-8px">
              <el-select v-model="search.position" @change="getList" popper-class="select-popper">
                <el-option
                  v-for="(option, index) in searchPostion"
                  :key="index"
                  :label="option.displayName"
                  :value="option.id"
                ></el-option> </el-select
            ></span>
            <span class="text-hex-666 ml-60px">时间：</span>
            <span>
              <el-date-picker
                size="small"
                class="max-w-330px"
                v-model="search.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                @change="getList"
                popper-class="date-popper"
              >
              </el-date-picker>
            </span>
            <span class="cursor-pointer ml-20px" @click="reset">重置</span>
          </div>
          <div class="mt-10px text-hex-999999 text-14px">相关结果: {{ page.total }}个</div>
        </div>
        <div class="h-[calc(100%-60px)] overflow-y-auto">
          <div
            :class="[
              'my-10px',
              index + 1 !== dataList.length ? 'border-b' : '',
              'border-hex-e6e6e6',
              'h-60px',
            ]"
            v-for="(item, index) in dataList"
            :key="item.id"
          >
            <div @click="liClick(item)" class="flex items-center cursor-pointer">
              <div :class="getTagBg(item.type)">
                {{ item.columnName }}
              </div>
              <div class="ml-10px items-center w-[calc(100%-70px)]">
                <div class="w-full pl-10px cursor-pointer" @click="liClick(it)">
                  <div class="flex items-center">
                    <p
                      class="text-14px text-hex-000 truncate w-[calc(100%-6px)] hover:text-hex-$portalPrimaryColor"
                    >
                      {{ item.title }}
                    </p>
                    <div class="items-center text-14px text-hex-999 text-right mr-10px">
                      {{ dayjs(item.creationTime).format('MM/DD') }}
                    </div>
                  </div>
                  <p v-if="item.summary !== null" class="text-12px text-hex-999 mt-10px truncate">
                    {{ item.summary }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="14">
        <el-card class="h-full w-full mr-10px" :body-style="{ height: '100%' }"> </el-card>
      </el-col> -->
    </el-row>

    <div class="float-right justify-center mb-20px">
      <el-pagination
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :page-sizes="[1, 15, 30, 45, 60, 75, 90]"
        :pager-count="5"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { ColumnTableSearchApi } from '@wiz-api/workbench-std'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import NavigationBarProps from '../components/NavigationBarProps'

const dataCategoryApi = new DataCategoryApi()
const columnTableSearch = new ColumnTableSearchApi()

export default {
  name: 'search',
  components: {
    NavigationBarProps,
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      startTimeRange: '',
      search: {
        position: '0',
        timeRange: [],
        sort: 'desc',
        startTime: '',
        endTime: '',
        type: null,
      },
      selectCategory: 'ColumnCategory',
      columnCategoryList: [],
      active: 'all',
      dataList: [],
      searchPostion: [
        {
          id: '0',
          displayName: '全部',
        },
        {
          id: '1',
          displayName: '标题',
        },
        {
          id: '2',
          displayName: '正文',
        },
      ],
      titleBar: [
        {
          name: '全部',
          activeName: 'all',
        },
        {
          name: '栏目',
          activeName: 'column',
        },
        {
          name: '新闻',
          activeName: 'news',
        },
        {
          name: '视频',
          activeName: 'video',
        },
        {
          name: '公告',
          activeName: 'notice',
        },
        {
          name: '图片',
          activeName: 'image',
        },
      ],
      searchText: '',
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  created() {
    const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-std']
    document.title = `搜索 - ${config?.title}`
    this.searchText = this.$route.query.text
    this.getDataCategory()
  },
  watch: {
    active: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.getList()
        }
      },
    },
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.searchText = val.query.text
          this.getDataCategory()
        }
      },
    },
  },
  methods: {
    getTagBg(type) {
      switch (type) {
        case 1:
          return 'rounded-4px bg-hex-$portalPrimaryBgColor text-hex-$portalPrimaryColor text-center pt-15px pb-15px text-12px overflow-hidden h-full w-60px'
        case 2:
          return 'rounded-4px bg-hex-f0f9ff text-hex-3b9bf0 text-center pt-15px pb-15px text-12px overflow-hidden h-full w-60px'
        case 3:
          return 'rounded-4px bg-hex-eaffef text-hex-25e154 text-center pt-15px pb-15px text-12px overflow-hidden h-full w-60px'
        default:
          return 'rounded-4px bg-hex-$portalPrimaryBgColor text-hex-$portalPrimaryColor text-center pt-15px pb-15px text-12px overflow-hidden h-full w-60px'
      }
    },
    liClick(item) {
      window.open(
        `${window.location.origin}${window.location.hash ? '/#' : ''}${
          this.routerBase
        }/integration/portal/ColumnDetail?id=${item.id}&type=${item.type}`
      )
    },
    async getDataCategory() {
      this.columnCategoryList = []
      const [err, res] = await dataCategoryApi.getByCode({
        code: this.selectCategory,
        includeDetails: true,
      })
      if (!err) {
        this.columnCategoryList = res.dataItems
        this.getList()
      }
    },
    changeSort() {
      if (this.search.sort === 'asc') {
        this.search.sort = 'desc'
      } else {
        this.search.sort = 'asc'
      }
      this.getList()
    },
    async getList() {
      switch (this.active) {
        case 'column':
          this.search.type = null
          this.columnCategoryList.forEach((element) => {
            if (element.displayName === '栏目') {
              this.search.category = element.id
            }
          })
          break
        case 'news':
          this.search.type = null
          this.columnCategoryList.forEach((element) => {
            if (element.displayName === '新闻') {
              this.search.category = element.id
            }
          })
          break
        case 'video':
          this.search.type = 3
          this.search.category = null
          break
        case 'notice':
          this.search.type = null
          this.columnCategoryList.forEach((element) => {
            if (element.displayName === '公告') {
              this.search.category = element.id
            }
          })
          break
        case 'image':
          this.search.type = 2
          this.search.category = null
          break
        case 'all':
          this.search.type = null
          this.search.category = null
          break
        default:
          this.search.type = null
          this.search.category = null
      }
      const [err, res] = await columnTableSearch.searchColumnTable(
        this.page.pageNo,
        this.page.pageSize,
        {
          type: this.search.type,
          category: this.search.category,
          keyword: this.search.position === '0' ? this.searchText : '',
          title: this.search.position === '1' ? this.searchText : '',
          summary: this.search.position === '2' ? this.searchText : '',
          startTime: this.search.timeRange.length > 0 ? this.search.timeRange[0] : '',
          endTime: this.search.timeRange.length > 0 ? this.search.timeRange[1] : '',
          sortBy: this.search.sort,
        }
      )
      if (!err && res) {
        this.dataList = res.items
        this.page.total = res.totalCount
      }
    },
    reset() {
      this.page = this.$options.data().page
      this.search.timeRange = this.$options.data().search.timeRange
      this.search.position = this.$options.data().search.position
      this.search.sort = this.$options.data().search.sort
      this.search.startTime = this.$options.data().search.startTime
      this.search.endTime = this.$options.data().search.endTime
      this.getList()
      // this.active = this.$options.data().active
    },
  },
}
</script>

<style lang="scss" scoped>
.selectBorder {
  ::v-deep .el-input__inner {
    border: none;
  }
  input::placeholder {
    color: red;
  }
}
.test {
  ::v-deep .el-radio-button__inner {
    background: none;
    border: none;
    color: red;
  }
}
</style>
